var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HighchartComponent',_vm._g({ref:"chartRef",attrs:{"options":_vm.chartOptions,"highcharts":_vm.hc}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }